import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { moreTestimonials } from '../data/testimonials';
export function MoreTestimonials() {
  return <section aria-label="More testimonials" className="mx-auto mt-12 w-full max-w-5xl" data-id="element-91" data-mp="20fowudtw93h2">
      <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-92" data-mp="25auta6kxa0je">
        ❤️ More People Who Have Already Applied The System
      </h2>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-93" data-mp="1cl5rhr0e1wgq">
        {moreTestimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i % 2 * 0.1} data-id="element-94" data-mp="1hjyv8rpvi93p" data-mpi={i} />)}
      </div>
    </section>;
}